export default __webpack_public_path__ + "static/media/titanium.bdd67497.png";